// Osprey Legacy — Design Tokens
// Used in Recharts, D3, and any programmatic styling

export const colors = {
  navy: {
    50: '#E8ECF4',
    100: '#C5CDDE',
    200: '#9DABC4',
    300: '#7489AA',
    400: '#566F96',
    500: '#385583',
    600: '#2F4A74',
    700: '#253D62',
    800: '#1C3050',
    900: '#0F1D33',
  },
  burgundy: {
    300: '#D1737C',
    500: '#8B2331',
    600: '#7A1E2B',
  },
  hunter: {
    300: '#66A876',
    500: '#2D6B3F',
    600: '#255A34',
  },
  gold: {
    300: '#E1BD66',
    500: '#B8860B',
    600: '#9A710A',
  },
  ivory: {
    100: '#FAF8F4',
    200: '#F5F1E8',
    300: '#EDE7D9',
  },
} as const;

// Chart color sequence (for pie charts, bar charts, etc.)
export const chartColors = [
  colors.navy[600],
  colors.burgundy[500],
  colors.hunter[500],
  colors.gold[500],
  colors.navy[300],
  colors.burgundy[300],
  colors.hunter[300],
  colors.gold[300],
  colors.navy[200],
  colors.burgundy[600],
];

// Currency formatter
export function formatCurrency(value: number, compact = false): string {
  if (compact) {
    if (Math.abs(value) >= 1_000_000_000) {
      return `$${(value / 1_000_000_000).toFixed(1)}B`;
    }
    if (Math.abs(value) >= 1_000_000) {
      return `$${(value / 1_000_000).toFixed(1)}M`;
    }
    if (Math.abs(value) >= 1_000) {
      return `$${(value / 1_000).toFixed(0)}K`;
    }
  }
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);
}

// Percentage formatter
export function formatPercent(value: number, decimals = 1): string {
  return `${(value * 100).toFixed(decimals)}%`;
}

// Module route config
export const modules = [
  {
    key: 'dashboard',
    label: 'Dashboard',
    path: '/',
    icon: 'LayoutDashboard',
    phase: 1,
  },
  {
    key: 'liquidity',
    label: 'Liquidity Runway',
    path: '/liquidity',
    icon: 'TrendingUp',
    phase: 3,
  },
  {
    key: 'capital',
    label: 'Capital Structure',
    path: '/capital',
    icon: 'Building2',
    phase: 3,
  },
  {
    key: 'estate-tax',
    label: 'Estate Tax Analysis',
    path: '/estate-tax',
    icon: 'Calculator',
    phase: 4,
  },
  {
    key: 'strategy',
    label: 'Strategy Workbench',
    path: '/strategy',
    icon: 'Puzzle',
    phase: 5,
  },
  {
    key: 'gifts',
    label: 'Gift & GST Tracker',
    path: '/gifts',
    icon: 'Gift',
    phase: 6,
  },
  {
    key: 'entities',
    label: 'Entity Modeler',
    path: '/entities',
    icon: 'Network',
    phase: 6,
  },
  {
    key: 'timing',
    label: 'Timing Overlay',
    path: '/timing',
    icon: 'Clock',
    phase: 7,
  },
  {
    key: 'reports',
    label: 'Reports & Export',
    path: '/reports',
    icon: 'FileText',
    phase: 7,
  },
] as const;
